import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Select from 'react-select'; 
const EditUserMenage = () => {
  const { id } = useParams();

  const [villas, setVilla] = React.useState([]);
  const [valueVilla, setValueVilla] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [l, setL] = useState(false);
  const [formData, setFormData] = useState({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    villas: []
  });

  useEffect(() => {
    // firebase.auth().onAuthStateChanged((user) => {
    if (id) {
      firebase.firestore().collection('usersMenage').doc(id).get().then(doc => {
        if (doc) {
          let d = doc.data()
          d.id = doc.id;
          setFormData(d)
          setValueVilla(d?.villas)
        }
      })
    } else {
      toast.error('Une erreur s\'est produite.');
    }
    // })
  }, [])

  const handleChange = e => {
    let d = { id: formData.id };
    d.firstName = formData.firstName;
    d.lastName = formData.lastName;
    d.email = formData.email;
    d.phone = formData.phone;
    d.villas = formData.villas;
    d[e.target.name] = e.target.value;
    setFormData(d);
  };



  const handleSubmit = e => {
    e.preventDefault();
    if (formData && formData.firstName && formData.lastName && formData.phone && formData.id) {
      const da = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        update_At: new Date(),
        villas: formData.villas,
      }
      setLoading(true);
      // console.log(da); 
      firebase.firestore().collection('usersMenage').doc(formData.id).update(da).then((res) => {
        setLoading(false);
        toast.success('Mise à jour terminé');
      }).catch(err => {
        setLoading(false);
        toast.error('Une erreur s\'est produite.');
      })
    } else {
      setLoading(false);
      toast.error('Veuillez remplir tout les champs.');
    }
  };
  const loadVilla = () => {
    firebase.firestore().collection('properties').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.nameHouse}` }
          s.push(dr)
        }

      })
      setVilla(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }
  const sendVilla = async () => {
    setL(true);
    const emailMenage = firebase.functions().httpsCallable("emailMenage") ;
     await emailMenage({email:  formData.email , name : `${formData.firstName} ${formData.lastName}`, link: 'https://bo-house.software/menage/u/'+id});
    toast.success("L'email a été envoyé avec succès");
    setL(false);
  }

  useEffect(() => {
    loadVilla()
  }, []);
  return (
    <Card>
      <FalconCardHeader title="Edition du profil de ménage" />
      <Card.Body className="bg-body-tertiary">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3 g-3">


            <Form.Group as={Col} lg={6} controlId="firstName">
              <Form.Label>Prénom</Form.Label>
              <Form.Control
                type="text"
                placeholder="Prénom"
                value={formData.firstName}
                name="firstName"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="lastName">
              <Form.Label>Nom de famille</Form.Label>
              <Form.Control
                type="text"
                placeholder="Last Name"
                value={formData.lastName}
                name="lastName"
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} lg={6} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={formData.email}
                name="email"
                disabled
              // onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="phone">
              <Form.Label>Téléphone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Phone"
                value={formData.phone}
                name="phone"
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group as={Col} md="5" controlId="villa">
              <Form.Label>Propriétés</Form.Label>
              <Select
                options={villas}
                isMulti
                closeMenuOnSelect={false}
                placeholder='Choisir les villas...'
                classNamePrefix="react-select"
                value={valueVilla}
                onChange={value => {
                  setValueVilla(value)
                  let d = formData;
                  d['villas'] = value;
                  setFormData(d);

                }}
              />
            </Form.Group>
          </Row>

          <div className="text-start">
            <Button variant="primary" type="submit" disabled={loading}>
              {!loading ? 'Mise à jour' : 'Chargement'}
            </Button>
            <br />
            <br />
            <Button variant="secondary" disabled={l} onClick={sendVilla}>
            {!l ? 'Envoyer le lien du planning par email' : 'Chargement'}
            </Button>

            <br />
            <br />
            <a href={`/menage/u/${id}`} target='_blank'>ouvrir le planning dans un nouvel onglet</a>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default EditUserMenage;
